module.exports = __webpack_public_path__ + "img/red_074.aec9334f.png";